"use client"

import { convertToLocale } from "@/lib/helpers/money"
import Image from "next/image"
import LocalizedClientLink from "@/components/molecules/LocalizedLink/LocalizedLink"
import { useTranslate } from "@tolgee/react"

export const OrderProductListItem = ({
  item,
  currency_code,
}: {
  item: any
  currency_code: string
  withDivider?: boolean
}) => {
  const { t } = useTranslate()
  const productHandle =
    item.product_handle ||
    item.product?.handle ||
    item.variant?.product?.handle
  const productHref = productHandle ? `/products/${productHandle}` : undefined
  const productTitle =
    item.variant?.product?.title || item.product?.title || item.product_title

  return (
    <div className="bb-order-line bg-white px-[20px] py-[16px] flex items-center gap-[16px] border-t border-[#F3F4F6]">
      <div className="bb-order-thumb w-[48px] h-[48px] bg-[#f3f4f6] border border-[#e5e7eb] rounded-[4px] flex items-center justify-center flex-shrink-0 overflow-hidden">
        {item.thumbnail ? (
          <Image
            src={item.thumbnail}
            alt={item.title}
            width={48}
            height={48}
            className="object-cover size-full"
          />
        ) : (
          <Image
            src="/images/placeholder.svg"
            alt={item.title}
            width={32}
            height={32}
            className="opacity-25"
          />
        )}
      </div>

      <div className="flex-1 min-w-0 flex flex-col">
        <div className="h-[20px] overflow-hidden">
          {productHref ? (
            <LocalizedClientLink href={productHref} target="_blank">
              <p className="bb-order-card-title text-[14px] font-medium leading-[20px] tracking-[-0.1504px] text-[#1e2939] truncate">
                {productTitle}
              </p>
            </LocalizedClientLink>
          ) : (
            <p className="bb-order-card-title text-[14px] font-medium leading-[20px] tracking-[-0.1504px] text-[#1e2939] truncate">
              {productTitle}
            </p>
          )}
        </div>

        <div className="h-[22px] overflow-hidden pt-[2px]">
          <p className="bb-order-card-meta text-[14px] font-normal leading-[20px] tracking-[-0.1504px] text-[#6a7282] truncate">
            {item.product_title || item.title}
          </p>
        </div>

        <div className="h-[22px] pt-[2px]">
          <p className="bb-order-card-meta text-[14px] font-normal leading-[20px] tracking-[-0.1504px] text-[#99a1af]">
            {t("order_product_list_item.variant")}: {item?.variant_title || item?.variant?.title} × {item?.quantity || 1}
          </p>
        </div>
      </div>

      <div className="shrink-0">
        <p className="bb-order-card-title text-[14px] font-medium leading-[20px] tracking-[-0.1504px] text-[#1e2939]">
          {convertToLocale({
            amount: item.unit_price,
            currency_code: currency_code,
          })}
        </p>
      </div>
    </div>
  )
}
